import SVGImage from './Image/SVGImage'

export type MaterialIconType = 'filled' | 'outlined' | 'round' | 'sharp' | 'two-tone'

export interface IconProps {
  name?: string
  image?: string
  customImageSrc?: string
  className?: string
  type?: MaterialIconType
  alt?: string
  loading?: 'eager' | 'lazy'
}

const CLASSNAME: Record<MaterialIconType, string> = {
  filled: 'material-icons',
  outlined: 'material-icons-outlined',
  round: 'material-icons-round',
  sharp: 'material-icons-sharp',
  'two-tone': 'material-icons-two-tone',
}

/** A Material Design Icon. */
export function Icon({
  alt,
  name,
  image,
  className,
  type = 'outlined',
  loading,
  customImageSrc,
}: IconProps): React.ReactElement {
  if (image) {
    return (
      <span className={className}>
        <img alt={alt} className="max-h-6" loading={loading} src={image} />
      </span>
    )
  } else if (customImageSrc) {
    return (
      <span className={className}>
        <SVGImage alt={alt} imageClassName="max-h-6" srcKey={customImageSrc} />
      </span>
    )
  }

  const iconClassName = CLASSNAME[type]
  const fullClassName = className ? `${iconClassName} ${className}` : iconClassName
  return <span className={fullClassName}>{name}</span>
}
